import { tw } from "@careinfo/tailwind";
import { classNames } from "../../utils/classNames";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
interface PropsType {
  active: string;
  handleTabChange: (v: "notification" | "notice" | "chat") => void;
}

export function NotificationTab({ active, handleTabChange }: PropsType) {
  const { data: noticeData } = useGetHook({
    queryKey: [`notice`],
    url: `${APIS.NOTICE}`,
    params: {
      limit: 1,
      is_active: true,
      offset: 0,
    },
  });

  return (
    <div
      className={tw`border-t border-b py-2 px-4 inline-flex items-center gap-x-10`}
    >
      <button
        className={classNames(
          active === "notification"
            ? tw`text-primary border-b-2 border-b-primary px-2 py-1  focus:outline-none`
            : tw`px-2 py-1  focus:outline-none`
        )}
        onClick={() => handleTabChange("notification")}
      >
        Notifications
      </button>
      <button
        className={classNames(
          active === "chat"
            ? tw`text-primary border-b-2 border-b-primary px-2 py-1  focus:outline-none`
            : tw`px-2 py-1  focus:outline-none`
        )}
        onClick={() => handleTabChange("chat")}
      >
        Messages
      </button>
      <button
        className={classNames(
          active === "notice"
            ? tw`text-primary border-b-2 border-b-primary px-2 py-1  focus:outline-none`
            : tw`px-2 py-1 focus:outline-none disabled:text-gray-500 disabled:cursor-not-allowed`
        )}
        onClick={() => handleTabChange("notice")}
      >
        Notice: {noticeData?.count}
      </button>
    </div>
  );
}
